
import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/do';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { User } from "../_models/user";


@Injectable()
export class AuthInterceptor implements HttpInterceptor
{

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    if (sessionStorage.getItem('currentUser') != null)
    {
      let user: User = JSON.parse(sessionStorage.getItem('currentUser'))
      const clonedreq = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + user.token)
      });
      return next.handle(clonedreq)
        .do(
          succ => { },
          err =>
          {
            if (err.status === 401)
              this.router.navigateByUrl('/login');
          }
        );
    }
    else
    {
      return next.handle(req);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/auth.interceptor.ts